import { getTGenderValue } from '~constants/gender';

import { alwaysVisibleFilters, emptyGridFilters } from '../model/constants';
import type { TGridFilters } from '../model/types';

export const updateQueryFilters = ({
	gridFilters,
	query,
}: {
	gridFilters: TGridFilters;
	query: URLSearchParams;
}) => {
	const restQuery = new URLSearchParams(query);

	Object.keys(gridFilters).forEach((key) => {
		restQuery.delete(key);
	});

	const { gender, ...restFilters } = gridFilters;
	const genderQueryValue = getTGenderValue(gender);
	if (genderQueryValue) {
		restQuery.set('gender', genderQueryValue);
	}

	Object.entries(restFilters).forEach(([key, value]) => {
		if (
			alwaysVisibleFilters.includes(key as keyof TGridFilters) ||
			value !== emptyGridFilters[key as keyof TGridFilters]
		) {
			restQuery.set(key, String(value));
		}
	});

	return restQuery;
};
